<template>
<!-- 机柜空调出风口/进风口温度曲线 -->
<div class="chart-line" style="height: 145px"></div>
</template>

<script>
import chartInitMixin from '@/views/mixin/chartInitMixin'
import { merge } from 'lodash'
import chartConfig from '@/utils/chartConfig'
import hexRgb from 'hex-rgb'
import * as echarts from "echarts";
import { genHourList } from '@/views/sascreen/utils/genValues'

const color = ['#259fff', '#ffc00e', '#f36067','#c793f2', '#7d63ee', '#45f8ff', '#5fd3fd']

export default {
  name: 'chart-line',
  components: {},
  mixins: [ chartInitMixin, ],
  props: {
    chartTitle: {
      type: String,
      required: false,
    },
    chartData: {
      type: Object,
      required: true,
    },
    colorIndex: {
      type: Number,
      required: false,
      default: 0
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler () {
        this.update()
      }
    }
  },
  methods: {
    update () {
      const series = this.chartData.seriesData
      if(!series) return
      // const labels = this.chartData.xAxisData
      const labels = genHourList(series[0].data.length)
      // 设置颜色
      series.forEach((item, index) => {
        const i = (index + this.colorIndex) % color.length
        item.color =  color[i]
      });
      const option = merge({}, chartConfig, {
        grid: {
          top: 10,
          right: 15,
        },
        color: series.map(item => item.color || 'rgb(0, 174, 255)'),
        title: {
          show: false,
          text: this.chartTitle,
          textStyle: {
            fontFamily: '"OPPOSans R", "阿里巴巴普惠体 R", PingFangSC-Medium, PingFangSC, Arial, Helvetica, 黑体, sans-serif',
            fontSize: 15,
            fontWeight: '100',
            color: '#FFF1D9',
            textShadowBlur: 0,
          },
          left: 'left',
          top: '0',
        },
        legend: {
          show: false,
          itemWidth: 8,
          itemHeight: 8,
          right: '0%',
          icon: 'circle',
          top: '0',
          textStyle: {
            fontSize: 10,
            color: "#fff",
          },
          data: series.map(s => s.name)
        },
        xAxis: {
          data: labels,
          boundaryGap: false,
          splitLine: {
            show: false,
            interval: 0,
            lineStyle: {
                color: 'rgba(255,255,255,0.2)' // 坐标轴X轴线条颜色
            }
          },
          axisLabel: { // 坐标轴样式
            interval: 0, // 强制显示所有标签
            rotate: 0, // 如果标签过长，可以旋转显示
            fontSize: 10,
            color: 'rgba(255,255,255,0.45)', // 坐标轴标签颜色
          },
        },
        yAxis: [
          {
            type: 'value',
            min: function (value) {
              return value.min - 0.5
            },
            max: function (value) {
              return value.max + 0.5
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: 'rgba(255,255,255,0.1)'
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255,255,255,0.1)'
              }
            },
            axisLabel: {
              formatter: function (value) {
                return value.toFixed(1)
              },
              color: 'rgba(255,255,255,0.45)',
              fontSize: 10,
            },
          },
        ],
        series: series.map(s => {
          const color = s.color || '#00aeff'
          const rgb = hexRgb(color)
          return {
            data: s.data,
            type: 'line',
            name: s.name,
            showSymbol: false,
            symbol: 'circle',
            symbolSize: 5,
            coordinateSystem: 'cartesian2d',
            smooth: true,
            itemStyle: {
              color,
              borderColor: s.color || '#00aeff',
              borderWidth: 2,
            },
            lineStyle: { color },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: `rgba(${rgb.red},${rgb.green},${rgb.blue},0.8)`
                },
                {
                  offset: 0.5,
                  color: `rgba(${rgb.red},${rgb.green},${rgb.blue},0)`
                },
                {
                  offset: 1,
                  color: `rgba(${rgb.red},${rgb.green},${rgb.blue},0)`
                }
              ])
            }
          }
        })
      }, this.option)
      //option.yAxis = merge({}, chartConfig.yAxis, { data: labels, type: 'value' })
      this.chart.setOption(option)
      // console.log('#Chart Option#', option)
    }
  }
}
</script>
